export default __webpack_public_path__ + "static/media/e93db083cd1ecf6e.86980dcc1a59a37df92de9f28dbd82b9.svg";